import React, { useEffect, useState } from "react";
import "./FormFieldsStyle.css";

const InputField = (props) => {
  const [isSpecialError, setIsSpecialError] = useState("");

  const [isLimitError, setIsLimitlError] = useState("");

  const handleChange = (e) => {
    let value = e?.target?.value; // Trim whitespace from the input value

    if (value.startsWith(" ")) {
      return;
    }

    if (value.length >= 157) {
      props?.inputValue?.current?.setAttribute("disabled", true);
      setIsLimitlError("Maximum character value is 156");
      return;
    }

    if (value.length > 0) {
      props?.inputValue?.current?.removeAttribute("disabled");
    } else {
      props?.inputValue?.current?.setAttribute("disabled", true);
    }

    if (props.flow === "email") {
      if (
        !/^[a-zA-Z0-9\s@.,]*$/.test(value) || // Updated regex pattern for email validation
        value.startsWith(".") ||
        value.startsWith(",")
      ) {
        props?.inputValue?.current?.setAttribute("disabled", true);
        setIsSpecialError("No Special characters are allowed");
        setIsLimitlError("");
      } else {
        setIsSpecialError("");
        setIsLimitlError("");
        localStorage.setItem(
          "inputValue",
          JSON.stringify({ key1: e.target.value })
        );
      }
    } else if (
      !/^[a-zA-Z0-9\s.,]*$/.test(value) ||
      value.startsWith(".") ||
      value.startsWith(",")
    ) {
      props?.inputValue?.current?.setAttribute("disabled", true);
      setIsSpecialError("No Special characters are allowed");
      setIsLimitlError("");
    } else {
      setIsSpecialError("");
      setIsLimitlError("");
      localStorage.setItem(
        "inputValue",
        JSON.stringify({ key1: e.target.value })
      );
    }
  };

  return (
    <>
      {console.log(isLimitError, isSpecialError)}
      <div className="form-group">
        <label className="sel" style={{ fontSize: "16px", color: "#444444" }}>
          {props.item.text}
          <span className="asterisk-icon"></span>
        </label>
        <input
          type="text"
          className="form-control"
          disabled={props.disable}
          defaultValue={(props.userInputObj && props.userInputObj.key1) || ""}
          onInput={(e) => handleChange(e)}
          // maxlength="156"
        />
        <span className="validate">&nbsp;</span>
        <div
          style={{
            color: "red",
            textAlign: "center",
            marginBlockStart: 10,
            fontSize: 12,
          }}
        >
          {isSpecialError && isSpecialError}
          {isLimitError && isLimitError}
        </div>
      </div>
    </>
  );
};

export default InputField;
